<template>
  <component :is="themeComponent" />
</template>

<script>
import { getHomeTheme } from "./themes";

export default {
  name: "HomeResolver",
  computed: {
    themeComponent() {
      return getHomeTheme(this.institutionType);
    },
    institutionType() {
      return this.$store.getters.institutionType || "softinya";
    }
  }
};
</script>
